export default __webpack_public_path__ + "static/media/042-grapes.70502431.svg";